import { createContext } from 'react';

// External embeds and audio opt into a scrollable feed preview before playback.
// Recorded video deliberately stays in the viewer's current comment mode.
// Editors and other scrollable surfaces do not need to change their mode.
const MediaViewportContext = createContext(null);
export default MediaViewportContext;

export function revealPlayer(element) {
  if (!element) return;
  let viewport = element.parentElement;
  while (viewport && viewport !== document.body) {
    if (/(auto|scroll)/.test(getComputedStyle(viewport).overflowY)) {
      const bounds = viewport.getBoundingClientRect();
      const player = element.getBoundingClientRect();
      const section = element.closest('.reaction-main-section, .reaction-quote');
      const author = section?.querySelector('.reaction-main-author, .reaction-quote__author');
      const inset = author && getComputedStyle(author).position === 'sticky' ? author.getBoundingClientRect().height : 0;
      const available = viewport.clientHeight - inset;
      // Keep the native controls reachable without scrolling the page behind
      // the fixed event heading or changing the editor's text selection.
      const top = bounds.top + viewport.clientTop + inset;
      if (player.top < top || player.bottom > top + available) {
        viewport.scrollTop += player.top - top - Math.max(0, (available - player.height) / 2);
      }
      return;
    }
    viewport = viewport.parentElement;
  }
}
